import React, { useEffect, useRef } from 'react';
import { profile } from '../mock';
import { Zap } from 'lucide-react';

export default function AboutSection() {
  const panelRef = useRef(null);

  // Subtle 3D tilt following cursor within the card
  useEffect(() => {
    const el = panelRef.current;
    if (!el) return;
    const handle = (e) => {
      const r = el.getBoundingClientRect();
      const cx = r.left + r.width / 2;
      const cy = r.top + r.height / 2;
      const dx = (e.clientX - cx) / r.width;
      const dy = (e.clientY - cy) / r.height;
      el.style.transform = `perspective(1200px) rotateX(${(-dy * 4).toFixed(
        2
      )}deg) rotateY(${(dx * 4).toFixed(2)}deg)`;
    };
    const reset = () => {
      el.style.transform = 'perspective(1200px) rotateX(0) rotateY(0)';
    };
    window.addEventListener('mousemove', handle);
    window.addEventListener('mouseleave', reset);
    return () => {
      window.removeEventListener('mousemove', handle);
      window.removeEventListener('mouseleave', reset);
    };
  }, []);

  const [intro, p1, p2, p3] = profile.aboutLines;

  return (
    <section id="about" className="section" style={{ paddingTop: 160 }}>
      <div className="twocol"
        style={{
          display: 'grid',
          gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1.2fr)',
          gap: 64,
          alignItems: 'center',
        }}
      >
        <div className="reveal">
          <div className="section-label" style={{ marginBottom: 24 }}>
            02  About
          </div>
          <h2 className="section-title" style={{ margin: 0 }}>
            The one
            <br />
            behind<br />
            the screen.
          </h2>
          <div
            className="mono"
            style={{
              marginTop: 32,
              fontSize: 11,
              letterSpacing: '0.3em',
              color: 'rgba(245,245,245,0.45)',
              display: 'flex',
              flexDirection: 'column',
              gap: 8,
            }}
          >
            <span>ROLE &mdash; CREATOR / DESIGNER / EDITOR</span>
            <span>STACK &mdash; CANVA &middot; ADOBE EXPRESS &middot; WORDPRESS</span>
            <span>STATUS &mdash; AVAILABLE FOR WORK</span>
          </div>
        </div>

        <div
          ref={panelRef}
          className="glass-card reveal"
          style={{
            padding: 48,
            transition: 'transform 200ms ease, border-color 250ms ease, background 250ms ease',
          }}
        >
          <div
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 10,
              padding: '6px 12px',
              borderRadius: 999,
              background: 'rgba(245,245,245,0.06)',
              border: '1px solid rgba(245,245,245,0.08)',
              marginBottom: 24,
            }}
          >
            <Zap size={14} strokeWidth={2} />
            <span
              className="mono"
              style={{
                fontSize: 10,
                letterSpacing: '0.3em',
                color: 'rgba(245,245,245,0.7)',
              }}
            >
              INTRO
            </span>
          </div>

          <p
            style={{
              fontFamily: 'Space Grotesk, sans-serif',
              fontSize: 'clamp(22px, 2.4vw, 32px)',
              lineHeight: 1.35,
              margin: 0,
              color: '#f5f5f5',
              letterSpacing: '-0.01em',
            }}
          >
            {intro}
          </p>

          <div
            style={{
              marginTop: 28,
              display: 'flex',
              flexDirection: 'column',
              gap: 18,
              color: 'rgba(245,245,245,0.72)',
              lineHeight: 1.7,
              fontSize: 15,
            }}
          >
            <p style={{ margin: 0 }}>{p1}</p>
            <p style={{ margin: 0 }}>{p2}</p>
            <p style={{ margin: 0, color: '#f5f5f5' }}>{p3}</p>
          </div>

          <div
            style={{
              marginTop: 36,
              display: 'flex',
              gap: 12,
              flexWrap: 'wrap',
            }}
          >
            {['Canva', 'Adobe Express', 'WordPress', 'CapCut', 'Photoshop'].map(
              (t) => (
                <span
                  key={t}
                  className="mono"
                  style={{
                    fontSize: 10,
                    letterSpacing: '0.25em',
                    padding: '6px 12px',
                    border: '1px solid rgba(245,245,245,0.12)',
                    borderRadius: 999,
                    color: 'rgba(245,245,245,0.65)',
                    textTransform: 'uppercase',
                  }}
                >
                  {t}
                </span>
              )
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
